/**
 * MKPlayer constants.
 * @internal
 */
export const MKConstants = {
    /**
     * HTTP Request default timeout in milliseconds.
     * 
     * Default to 30 milliseconds.
     */
    HTTP_REQUEST_DEFAULT_TIMEOUT_MSECS: (30 * 1000),

    /**
     * Azuki fixed contract version to be used with Azuki (TVP Backend) requests in the header.
     */
    AzukiIMC: "IMC7.5.0_XX_Dx.x.x_Sx",

    /**
     * Azuki default ownerUid.
     */
    AzukiDefaultOwnerUid: "azuki",

    /**
     * Live event pregame tune delta offset in milliseconds.
     * 
     * Currently value is 75 minutes (in milliseconds).
     */
    LiveEventPregameTuneDelta: ((75 * 60) * 1000),

    /**
     * DRM Platform
     */
    DrmPlatform: {
        Widevine: "HTML5",
        Fairplay: "HTML5_FPS",
        Playready: "HTML5_PR"
    },

    /**
     * DRM Key Systems
     */
    DrmKeySystem: {
        Widevine: "com.widevine.alpha",
        Playready: "com.microsoft.playready",
        Fairplay: "com.apple.fps.1_0"
    },

    /**
     * Analytics Type
     */
    AnalyticsType: {
        Bitmovin: 0,
        Kibana: 1,
        Conviva: 2
    },

    /**
     * Key for the player state
     */
    XPlayerState: "x-player-state",

    /**
     * Start playback position for VOD in user engagement header
     */
    StartPlaybackPosition: "startPlaybackPosition",

    /**
     * Relative playback position for VOD when that specific beacon was passed
     */
    RelativePlaybackLocation: "relativePlaybackLocation",

    /**
     * Full user engagement header
     */
    XUserEngagementData: "x-tv3-user-engagement-data",

    /**
     * Error code prefixes for different error modules.
     */
    ErrorCodeTemplate: {
        /**
         * Azuki error code template.
         */
        AzukiError: "4-6{submodule}-{code}",

        /**
         * Player error code template.
         */
        PlayerError: "4-7{submodule}-{code}",

        /**
         * Program restrictions error code template.
         */
        ProgramRestrictionError: "4-80-{code}",

        /**
         * Adobe Primetime Session Concurrency error code template.
         */
        AdobePrimetimeSessionConcurrencyError: "4-81-{code}"
    },

    /**
     * EpochTimeCheck: used to check if startOffset or seek time is relative or absolute epoch time
     */
    EpochTimeCheck: 1000000000,

    /**
     * Maximum number of Cdn's per Priority Group in Azuki Roll Response.
     */
    MAX_CDNS_PER_PRIORITY_GROUP: 20

};
Object.freeze(MKConstants);